




import { Component, Vue } from "vue-property-decorator";
import { AuthModule } from "@/store/auth.module";
import { ContractsModule } from "@/store/contracts.module";
import { DialogsModule } from "@/store/dialogs.module";

@Component
export default class FRedirect extends Vue {
  async created() {
    await this.conditions();
  }

  conditions() {
    const user = AuthModule.user as IUser;
    if (!user.org_data.isEmailVerified && AuthModule.isEmailMutationAvailable) {
      DialogsModule.setEmailConfirmationDialog({
        show: true,
        isSent: false,
      });
      return this.$router.push("/profile");
    }
    if (ContractsModule.contracts.length == 1) {
      const contract = ContractsModule.contracts[0];
      return this.$router.push("/contracts/" + contract.contract_rid);
    }
    return this.$router.push("/contracts");
  }
}
